import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EasybillService } from 'src/app/services/easybill.service';
import { NotificationService } from 'src/app/services/notification.service';

export interface DialogAssignVrsData {
  licenceGuid: string;
  currentVrs?: string;
  projectName?: string;
}

@Component({
  selector: 'app-dialog-assign-vrs',
  templateUrl: './dialog-assign-vrs.component.html',
  styleUrl: './dialog-assign-vrs.component.scss',
})
export class DialogAssignVrsComponent {
  form = new FormGroup({
    vrs: new FormControl('', [Validators.required, Validators.minLength(16)]),
    projectName: new FormControl(''),
  });

  saving = false;
  errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<DialogAssignVrsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogAssignVrsData,
    private easybillService: EasybillService,
    private _notification: NotificationService,
  ) {
    this.form.get('projectName')?.setValue(this.data.projectName ?? '');
  }

  assign(): void {
    if (this.form.invalid || this.saving) {
      return;
    }
    this.saving = true;
    this.errorMessage = '';
    const dto = {
      vrs: this.form.get('vrs')?.value ?? '',
      projectName: this.form.get('projectName')?.value || undefined,
    };
    this.easybillService.assignVRS(this.data.licenceGuid, dto).subscribe({
      next: (res) => {
        this.saving = false;
        if (res.success) {
          this._notification.addMessage({ text: 'easybill.assignVrsSuccess' });
          this.dialogRef.close(true);
        } else {
          this.errorMessage = res.message ?? 'easybill.assignVrsFailed';
        }
      },
      error: (err) => {
        this.saving = false;
        this.errorMessage = err?.error?.error ?? 'easybill.assignVrsFailed';
      },
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
